import React, {useContext, useEffect, useState} from 'react';
import {AppStoreContext} from "components/Mall/AppStore/AppStore";
import {ExceedApiContext} from "containers/App/ExceedApi";
import {Card, Navigator, Page} from 'react-onsenui';
import {useHistory, useLocation} from "react-router";
import './Tasks.css'
import Task from "./Task";
import ExceedToolbar from 'components/ExceedToolbar';
import BackButton from 'components/BackButton';
import {TemplateNameRibbon} from '@exceed.ai/exceed-utils'
import queryString from 'query-string';
import {switchProject} from "components/SwitchProject";

const Tasks = () => {
    const ExceedApi = useContext(ExceedApiContext);
    const AppStore = useContext(AppStoreContext);
    let location = useLocation();
    let history = useHistory();

    const [tasks, setTasks] = useState(undefined);
    const [taskId, setTaskId] = useState(undefined);

    useEffect(() => {
        let currentSearch = queryString.parse(location.search);

        const fetchTasks = async () => {
            let tasks = await ExceedApi.getWaitingToApprovedMessages(AppStore.getSelectedBot.id, false, AppStore.getAdminDetails.id, undefined);
            if (currentSearch.taskId) {
                if (!tasks.some(x => x.id === currentSearch.taskId)) {
                    let relatedBotId = await ExceedApi.getWaitingCommBotId(AppStore.getSelectedBot.id, currentSearch.taskId)
                    if (relatedBotId) {
                        if (relatedBotId !== AppStore.getSelectedBot.id) {
                            switchProject(relatedBotId, ExceedApi, history, `${location.pathname}${location.search}`)
                            return;
                        }
                    }
                }
                setTaskId(currentSearch.taskId)
            } else {
                setTaskId(undefined)
            }

            setTasks(tasks)
        }


        if (!tasks) {
            fetchTasks();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if (!tasks) return null;

    const onCardClicked = async (task, navigator) => {
        await navigator.pushPage({
            title: task.id,
            backButton: <BackButton navigator={navigator} text={`All tasks ${tasks.length}`}/>,
            task: task
        });
    }

    const renderPage = (route, navigator) => {
        if (route.Component) {
            let {Component, title} = route;
            return <Page key={`comp_${title}-${new Date().getTime()}`}
                         contentStyle={{display: "flex", flexDirection: "column"}}>
                <Component key={`comp_${title}-${new Date().getTime()}`} navigator={navigator}/>
            </Page>
        } else if (route.task) {
            return <Page key={route.title}>
                <Task task={route.task} navigator={navigator}/>
            </Page>
        }
    }

    const TasksList = ({navigator, tasks}) => <div className="flex_column">
        <ExceedToolbar/>
        <div
            key={`tasks`}
            id="tasks"
            className="flex_column exceed_page">

            <div className="flex_column" style={{alignItems: "baseline"}}>
                <div style={{
                    color: "#929191",
                    fontSize: "16px",
                }}>{`Hello, ${AppStore?.getAdminDetails?.firstName}`}</div>
                <div style={{fontSize: "20px"}}>{`You've got ${tasks.length} open tasks`}</div>
                <br/>
            </div>

            <div className="flex_column">
                {
                    tasks.map((task, idx) => {

                        let contactName = undefined;
                        if (task.message.to) {
                            contactName = task.message.to[0].personal ? task.message.to[0].personal : (task.message.to[0].address.indexOf("@") !== -1 && task.message.to[0].address.split("@")[0]);
                        } else if (task.message.toNumber && task.message.toName) {
                            contactName = task.message.toName;
                        }

                        const isEscalationTask = task.message.templateType === "Default Email";

                        return <div style={{paddingBottom: "5px"}}><Card key={task.id} className="miniTaskCard"
                                                                         onClick={() => onCardClicked(task, navigator)}>
                            <div className="flex_row">
                                < div className="circle">
                                    <span className="initials">{contactName[0]}</span>
                                </div>
                                <div className="task_value flex_column"
                                     style={{
                                         justifyContent: "space-around",
                                         paddingLeft: "10px"
                                     }}>
                                    <div>{contactName}</div>
                                    <div style={{color: "#888888", fontSize: "13px"}}>
                                        {
                                            task.senderPlatform === "EMAIL" ? (task.message.to[0].address) : (task.message.toNumber)
                                        }
                                    </div>
                                </div>
                            </div>

                            <p>
                                <span className="task_value">{task.playbookInfo.playbookName}</span>
                            </p>

                            <div>
                                {
                                    !isEscalationTask ? <TemplateNameRibbon
                                        templateName={task.message.templateType}/> : "None suggested"
                                }
                            </div>

                        </Card></div>
                    })
                }
            </div>
        </div>
    </div>;

    return (
        <Navigator
            renderPage={renderPage}
            animation={"slide"}
            initialRoute={{
                title: 'Exceed.ai',
                Component: ({navigator}) => !taskId ? <TasksList navigator={navigator} tasks={tasks}/> :
                    <Task navigator={navigator} task={tasks.find(x => x.id === taskId)}/>
            }}
        />
    );
}

export default Tasks;